import request from '@/utils/request'

// 查询银行手续费配置列表
export function listBankInfo(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/bank.listBankInfo',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 物业端查询银行渠道（含每笔手续费，申请提现选择银行使用）
export function listBankInfoForStore(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/bank.listBankInfoForStore',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增银行手续费配置
export function saveBankInfo(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/bank.saveBankInfo',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改银行手续费配置
export function updateBankInfo(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/bank.updateBankInfo',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除银行手续费配置
export function deleteBankInfo(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/bank.deleteBankInfo',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
